import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=379a2f0e&scoped=true&"
import script from "./HelpList.vue?vue&type=script&lang=js&"
export * from "./HelpList.vue?vue&type=script&lang=js&"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=379a2f0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a2f0e",
  null
  
)

export default component.exports